import { forwardRef, MutableRefObject } from 'react';
import styles from './FormTextarea.module.scss';
import cn from 'classnames';
import { FormTextareaProps } from '@kronoss/components/FormTextarea/FormTextarea.props';
import { TextareaAutosize } from '@mui/material';

type TextareaRef = MutableRefObject<HTMLTextAreaElement>;

const FormTextarea = forwardRef<TextareaRef, FormTextareaProps>(
  (props: FormTextareaProps, ref) => {
    const { label, error, textareaClassName, ...rest } = props;
    return (
      <div className={cn(styles.FormTextarea, error && styles.Error)}>
        {label && <div className={styles.Label}>{label}</div>}
        <TextareaAutosize
          ref={ref as any}
          {...rest}
          className={cn(styles.Textarea, textareaClassName)}
        />
      </div>
    );
  },
);

export default FormTextarea;
